"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AboutAppLinksWidget = exports._AboutAppLinksWidget = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _shapes = require("../../skybase-core/shapes");

var _widgetsI18n = require("../widgets-i18n");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line no-underscore-dangle
var _AboutAppLinksWidget = function _AboutAppLinksWidget(props) {
  var _ = props.intl.formatMessage;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", null, _(_widgetsI18n.messages.kistlerCorporate)), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "kistler-home-page",
    href: "https://www.kistler.com",
    target: "_blank",
    rel: "noopener noreferrer"
  }, _(_widgetsI18n.messages.kistlerHomePage))), /*#__PURE__*/_react.default.createElement("h3", null, _(_widgetsI18n.messages.customerServicesAndSupport)), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "kisler-contact",
    href: "https://www.kistler.com/about-us/contact",
    target: "_blank",
    rel: "noopener noreferrer"
  }, _(_widgetsI18n.messages.kistlerContactInformation))), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "kistler-terms-and-conditions-sales-service",
    href: "https://www.kistler.com/us/en/kistler-instrument-corporation-terms-and-conditions-for-sales-and-services",
    target: "_blank",
    rel: "noopener noreferrer"
  }, _(_widgetsI18n.messages.termsAndConditionsForSalesAndService))), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "kistler-terms-and-conditions-purchase",
    href: "https://www.kistler.com/terms-conditions-of-purchase",
    target: "_blank",
    rel: "noopener noreferrer"
  }, _(_widgetsI18n.messages.termsAndConditionsOfPurchase))));
};

exports._AboutAppLinksWidget = _AboutAppLinksWidget;
_AboutAppLinksWidget.propTypes = {
  intl: _shapes.intlShape.isRequired
};
_AboutAppLinksWidget.defaultProps = {};
var AboutAppLinksWidget = (0, _reactIntl.injectIntl)(_AboutAppLinksWidget);
exports.AboutAppLinksWidget = AboutAppLinksWidget;
//# sourceMappingURL=about-app-links-widget.js.map